import {appContainer} from "../contexts/app";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate} from "./hooks";
import FacilityRecordFactory from "./facility-record";

export default app => {
  const service = app.service("api/facilities");

  const FacilityRecord = FacilityRecordFactory(service);
  appContainer.FacilityRecord = FacilityRecord;
  app.set("FacilityRecord", FacilityRecord);

  const validateFacility = validate({
    name: "Facility name is required.",
    short_name: "Facility short name is required.",
    address: "Facility address is required."
  });

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateFacility],
      update: [fromImmutable, validateFacility],
      patch: [
        fromImmutable,
        validateFacility,
        context => {
          console.log(context);
        }
      ],
      remove: []
    },

    after: {
      all: [toImmutable(FacilityRecord)],
      find: [setListInState("facilities")],
      get: [setInState("facilities")],
      create: [setInState("facilities")],
      update: [setInState("facilities")],
      patch: [setInState("facilities")],
      remove: [deleteInState("facilities")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/facilities.js